import React from 'react';
import { Check } from 'lucide-react';
const POINTS = [{
  title: 'Locally Owned in Gilbert',
  text: 'We live and work in the East Valley. We know Arizona homes, desert landscaping, and what holds up in the heat.'
}, {
  title: 'Professional-Grade LED',
  text: 'We install durable, energy-efficient brass and aluminum fixtures — not the plastic kits from the hardware store.'
}, {
  title: 'Custom Design, No Guesswork',
  text: 'Every property gets a tailored lighting plan. We show you exactly how it will look before we install.'
}, {
  title: 'Backed by a Warranty',
  text: 'Our workmanship and fixtures are guaranteed, so your investment keeps shining for years to come.'
}];
const WHY_IMG = 'https://cdn.magicpatterns.com/uploads/ctfsHmmy6cKNXStvG4ezVw/Screenshot_2026-07-21_103139.png';
export function WhyUs() {
  return <section id="why-us" className="w-full border-y border-border bg-card py-20 lg:py-28" data-id="element-171" data-mp="3nau5accgnsxe">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8" data-id="element-172" data-mp="3nd6r50lcanfq">
        <div className="order-2 lg:order-1" data-id="element-173" data-mp="3j9mrqbm9tdxq">
          <span className="font-display text-lg tracking-wide text-accent" data-id="element-174" data-mp="3jaed6tm5lvaa">Why Choose Us</span>
          <h2 className="mt-2 font-display text-4xl leading-tight text-foreground sm:text-5xl" data-id="element-175" data-mp="3naokc9lomrqq">
            The Valley’s Trusted Lighting Pros
          </h2>
          <p className="mt-4 text-lg text-muted-foreground" data-id="element-176" data-mp="w5ej1arwkvv">
            Homeowners across Gilbert, Chandler, Mesa, and Queen Creek choose us for lighting
            that looks incredible and works reliably.
          </p>

          <ul className="mt-8 space-y-6" data-id="element-177" data-mp="av4g5zx4fg9d">
            {POINTS.map(p => <li key={p.title} className="flex gap-4" data-id="element-178" data-mp="ew6hcmalm2dz">
                <span className="mt-0.5 flex h-7 w-7 flex-none items-center justify-center rounded-full bg-accent text-accent-foreground" data-id="element-179" data-mp="euvaueprqgj6">
                  <Check className="h-4 w-4" aria-hidden="true" data-id="element-180" data-mp="2gmrrg2qsmgkt" />
                </span>
                <div data-id="element-181" data-mp="3jxxaxghsazlf">
                  <h3 className="font-display text-xl text-foreground" data-id="element-182" data-mp="3jx5i2dfknfyu">{p.title}</h3>
                  <p className="mt-1 leading-relaxed text-muted-foreground" data-id="element-183" data-mp="3ez4241dfzwrl">{p.text}</p>
                </div>
              </li>)}
          </ul>
        </div>

        <div className="order-1 lg:order-2" data-id="element-184" data-mp="3swivtiaqaqpd">
          <img src={WHY_IMG} alt="Arizona home facade beautifully lit with warm uplighting at dusk" className="w-full rounded-xl border border-border object-cover shadow-2xl" data-id="element-185" data-mp="3ows51el7caku" />
        </div>
      </div>
    </section>;
}